import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { useQueryClient } from "react-query";

import ClientAdd from "./ClientAdd";
import BulkUploadModal from "../Shared/BulkUpload/BulkUploadModal";
import { clientBulkUploadApi } from "../../utils/api/bulkUpload";
import AppContext from "../../contexts/AppContext";
import RolesContext from "../../contexts/RolesContext";
import ResourceIndex from "../Shared/ResourceIndex/ResourceIndex";
import AppDivisionContext from "../../contexts/AppDivisionContext";
import DivisionError from "../Shared/DivisionError/DivisionError";
import { getDivisionResourceName } from "../../hooks/divisionResource";
import { useTerminology } from "../../hooks/useTerminology";
// import { useMatomo } from "@datapunt/matomo-tracker-react";

const Clients: React.FC<{}> = () => {
  const roleStore = useContext(RolesContext);
  const appDivisionContext = useContext(AppDivisionContext);
  const appContext = useContext(AppContext);
  const terms = useTerminology();
  const queryClient = useQueryClient();
  const [showBulkUpload, setShowBulkUpload] = useState(false);
  const resourceName = getDivisionResourceName("clients-paginated");
  // const { trackPageView } = useMatomo();

  if (!appDivisionContext.appDivisionId) {
    return <DivisionError resource="clients" />;
  }

  // useEffect(() => {
  //   trackPageView({});
  // }, [trackPageView]);

  return (
    <ResourceIndex
      resourceName={resourceName}
      emptyMessage={`No ${terms.entityPlural} found`}
      resourceQueryProps={{ divisionId: appDivisionContext.appDivisionId }}
      resourceTableHeaders={[
        ["Name", "name"],
        ["Address", "f_address"],
        ["Date Created", "f_created_at"],
      ]}
      resourceSearchProps={["name", "f_address", "f_created_at"]}
      enableRead={roleStore.userHasPermission("read", "Client")}
      enableEdit={false}
      enableCallToAction={roleStore.userHasPermission("create", "Client")}
      callToActionContent={`Add ${terms.entity}`}
      searchInputPlaceholder={`Search ${terms.entityPlural}`}
      renderReader={client => {
        return (
          <Redirect
            to={appDivisionContext.getPath(`/clients/${client.id}`)}
            push
          />
        );
      }}
      renderCallToAction={handleClose => {
        return <ClientAdd handleClose={handleClose} />;
      }}
      enablePagination
      hideCallToActionInMobile={false}
      extraHeaderActions={
        appContext.get("user")?.roleName === "Super Admin" && (
          <>
            <button className="outline" onClick={() => setShowBulkUpload(true)}>
              Add Bulk Client
            </button>
            {showBulkUpload && (
              <BulkUploadModal
                entity="Client"
                api={clientBulkUploadApi}
                handleClose={() => setShowBulkUpload(false)}
                onCreated={() =>
                  queryClient.invalidateQueries({
                    predicate: query => String(query.queryKey).startsWith(resourceName),
                  })
                }
              />
            )}
          </>
        )
      }
    />
  );
};

export default Clients;
